import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./auth/slice";
import { logSlice } from "./questionStore/logSlice";
import { AuthAPI } from "../apis/AuthAPI";
import { setTokenAndMe, logout } from "./auth/actions";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    log: logSlice.reducer,
    // login: loginSlice.reducer,
    // editProfile: editProfileSlice.reducer,
    // questions: questionSlice.reducer,
    // demands: demandSlice.reducer,
    // teacherDemands: teacherDemandSlice.reducer,
    // teacherDemandsManager: teacherDemandManagerSlice.reducer,
    // teacherDemandManagerQuestion: teacherDemandManagerQuestionSlice.reducer,
    // demandsManager: demandManagerSlice.reducer,
    // disciplines: disciplineSlice.reducer,
    // organizations: organizationSlice.reducer,
    // userAdmin: userAdminSlice.reducer,
    // userColaborator: userColaboratorSlice.reducer,
    // userTeacher: userTeacherSlice.reducer,
    // userStudent: userStudentSlice.reducer,
    // exams: examsSlice.reducer,
    // layouts: layoutsSlice.reducer,
    // studentExams: studentExamsSlice.reducer,
    // units: unitSlice.reducer,
    // courses: courseSlice.reducer,
    // classes: classSlice.reducer,
    // corrections: correctionSlice.reducer,
    // registrations: registrationSlice.reducer,
    // correctionExams: correctionExamSlice.reducer,
    // correctionStudents: correctionStudentSlice.reducer,
    // correctionQuestions: correctionQuestionSlice.reducer,
    // dashboard: dashboardSlice.reducer,
    // logs: logSlice.reducer,
    // uploadExam: uploadExamSlice.reducer,
    // tests: testSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const getAsyncStorage = () => {
  console.log("store::getAsyncStorage");
  return (dispatch) => {
    let token = localStorage.getItem("token");

    if (token) {
      AuthAPI.me(token)
        .then((result) => {
          dispatch(setTokenAndMe({ token: token, me: result.data.data }));
        })
        .catch((e) => {
          console.log(
            `Error getAsyncStorage::AuthAPI::me ${JSON.stringify(e)}`
          );
          /* eslint-disable eqeqeq */
          if (
            (e.errors !== undefined && e.errors[0].status === 401) ||
            (e.errors !== undefined && e.errors[0].status === 403) ||
            e.status === 401 ||
            e.status === 403 ||
            e === 403
          ) {
          /* eslint-enable eqeqeq */
            console.log("Loggin out....");
            dispatch(logout());
          }
        });
    } else {
      console.log(`Error getAsyncStorage::getItem::result`);
      dispatch(logout());
    }
  };
};

store.dispatch(getAsyncStorage());
